import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    fetchPaymentProgramDetails,
} from "actions";
import { Map, List } from "immutable";
import {
    Drawer,
    Layout,
    PageHeader,
    Tag,
    Row,
    Col,
    Tooltip,
    Button,
    message
} from "antd";
import _startCase from "lodash/startCase";
import _lowerCase from "lodash/lowerCase";
import { SupplyChainRecord, CaseSanctionRecord } from "records";
import PaymentProgramDetailsTabs from "./tabs";
import PaymentProgramService from "services/payment-program-service";
import { LoaderSkeleton } from "components";
import { STATE_STATUS } from "constants";
import "styles/case-details.css";
import "styles/drawer-overrides.css";
import { getDataFromQueryString } from "../../utils";

class PaymentProgramDetailsDrawer extends React.Component {
    state = {
        visible: !!this.props.caseId,
        expanded: false,
        isRiskApprover: null,
        action: null,
        takeAction: false,
        showDocuments: false,
        disableActionButton: false,
        documentsList: [],
        case_task_updated: false,
        casesList: new List([]),
        fetchedCasesList: false,
        showSupplyChainRemarks: false,
        are_sellers_same: false,
        ledger_masters: [],
        caseLedgerStatus: null,
    };
    isLoading() {
        if (!this.props.status || this.props.status !== STATE_STATUS.FETCHED) {
            return false;
        }
        return false;
    }

    openDocumentsDrawer = (documents, doc, fileName) => {
        let docsList =
            documents &&
            documents.size &&
            documents.map(_ => (
                {
                    file: _.getIn(["data", "file", "file"]),
                    fileName: _.getIn(["data", "file", "file_name"])
                }
            ));
        this.setState({
            showDocuments: true,
            documentsList: docsList ? docsList : new Map({ fileObj: { file: doc, fileName } })
        });
    };

    onDrawerClose = () => {
        this.setState(
            {
                visible: false
            },
            () => {
                this.props.history.goBack();
            }
        );
    };

    viewCaseNotes = () => {
        const actionDetails = this.props.checklist.toJS().filter(_ => _.case.id === this.props.caseId);
        const actionDetailsId = actionDetails[0].action_detail_id;
        this.props.history.replace(
            `${this.props.location.pathname}?ordering=${getDataFromQueryString("ordering")}`,
            {
                ...this.props.location.state,
                case_notes: {
                    actionDetailsId: actionDetailsId,
                    stageId: this.props.stageId,
                    case_notes_view: true
                }
            }
        );
    };

    
    proceedAndReferBack = (status) => {
        if(status === "proceed"){
            PaymentProgramService.proceedPPCase(this.getActiveChecklist.getIn([0  , "id"])).then((response) => {
                if(response.status === 200){
                    message.success("Case Proceed Successfully");
                    this.redirectToOrderingPage();
                }else{
                    message.error("Some Error Occured");
                }
            });
        }else{
            PaymentProgramService.rejectPPCase(this.getActiveChecklist.getIn([0  , "id"])).then((response) => {
                if(response.status === 200){
                    message.success("Case Refer Back Successfully");
                    this.redirectToOrderingPage();
                }else{
                    message.error("Some Error Occured");
                }
            });
        }
    };

    redirectToOrderingPage= () => {
        this.props.history.replace(`/app/payment-program/?ordering=${getDataFromQueryString("ordering")}`);
        setTimeout(() => {
            this.props.fetchPaymentProgramDetails(getDataFromQueryString("ordering"), 1, 10 , {});
        }, 500);

    }
        
        docArray = (docParent) => {
            const docStatus = [];
            docParent.map((_) => {
                for (let key in _) {
                    if (key === "entity") {
                        for (let k in _["entity"].value) {
                            if (_["entity"].value[k].type === "doc") {
                                docStatus.push(_["entity"].value[k].documents);
                            }
                        }
                    } else {
                        _[key].value.map((item) => {
                            for (let k in item) {
                                if (item[k].type === "doc") {
                                    docStatus.push(item[k].documents);
                                }
                            }
                        });
                    }
                }
            });
            
            return docStatus;
        }

        getFileExtensionFromUrl = (url) => {
            return url.split(/[#?]/)[0].split(".").pop().trim();
        }

        getFinalCaseDocument = () => {
            if(this.caseChecklist && this.caseChecklist.size){
                let allApplicants = this.caseChecklist.getIn(["extra_data" ,  "checklist" , "onboarding" , "applicants" , "value" ]);
                if(allApplicants){
                    let newArr = Object.values(this.caseChecklist.getIn(["extra_data" ,  "checklist" , "onboarding" , "entity" , "value"]));
                    allApplicants.map(_ => (newArr.push(Object.values(_))));
                    let allDocs = this.filterData("documents" , newArr.flat());
                    if(this.caseChecklist.getIn(["dealer_constitution"]) === "Proprietorship"){
                        allDocs = allDocs.filter(_ => _.document_name !== "Company Pan");
                    }
                    return allDocs;
                }
            }
            return [];
        }

        get isEditAccess() {
            return (this.props.permissions && this.props.permissions.size && this.props.permissions.get("page_dbt_bulk_assign")) ? true : this.props.permissions.get("page_dbt_edit") &&  (this.getCheclist.size && this.getCheclist.getIn([0, "open_task_this_user", "id"], "") === this.props.userDetails.id);
        }


        caseActions = () => {
            if (getDataFromQueryString("ordering") == "2" && this.isEditAccess){
                return [
                            
                    this.getFinalCaseDocument().every(_ => _.documents[0].status === "Approved") ?
                        <Button
                            key={"proceed"}
                            type={"primary"}
                            onClick={() => this.proceedAndReferBack("proceed")}
                        >
                            Proceed
                        </Button>
                        : this.getFinalCaseDocument().every(_ => (_.documents[0].status === "Rejected" || _.documents[0].status ===  "Approved")) ?  <Button
                            key={"proceed"}
                            type={"primary"}
                            onClick={() => this.proceedAndReferBack("refer")}
                        >
                            Refer
                        </Button>
                            : null
                ];
            }            
            return [];
        };

        get getCheclist(){
            return this.props.checklist.filter(_ => _.id === this.props.caseId);
        }

    filterData = (type , data) => {
        if(type === "info"){
            return data.filter(_ => _ && _.type === "info");
        }else if(type === "documents"){
            return data.filter(_ => (_ && _.type === "doc" && _.documents.length));
        }
    }

    get getActiveChecklist(){
        return this.props.checklist.filter(_ => _.id === this.props.caseId);
    }

    get caseChecklist(){
        //extra api data
        return Map(this.props.caseCheckListData.getIn([this.props.caseId ,"data" ]));
    }

    getCompanyDetailsTitle = () => {
        return (
            <React.Fragment>
                <Tooltip className="overflowTextWrap"  title={`${_startCase(_lowerCase(getDataFromQueryString("dealer_name"))) || ""} (${this.caseChecklist.getIn(["extra_data" , "payer_gstin"] , "")})`}>
                    {(_startCase(_lowerCase(getDataFromQueryString("dealer_name"))) || "") + " " + this.caseChecklist.getIn(["extra_data" , "payer_gstin"] , "")}
                </Tooltip>
                <span style={{
                    color: "#f9f9f9"
                }}> {this.getActiveChecklist.getIn([0   , "id"] , "")}
                </span>
            </React.Fragment>
        );
    }

    render() {
        const {
            companyId,
            caseId,
            tab,
            history,
        } = this.props;
        return (
            <React.Fragment>
                <Drawer
                    visible={this.state.visible}
                    closable={false}
                    destroyOnClose={false}
                    mask={true}
                    maskClosable={true}
                    placement={"right"}
                    onClose={this.onDrawerClose}
                    height={"100vh"}
                    width={"100%"}
                    className={"case-details-drawer scrollable-drawer"}
                >
                    <Layout style={{ height: "inherit" }}>
                        <LoaderSkeleton loading={this.isLoading()}>
                            <Row className={"h-100 case-detail-row"}>
                                <Col span={24} className={"case-detail-page-header"}>
                                    <PageHeader
                                        className={"drawerExtraButtons header-title-Width"}
                                        title={this.getCompanyDetailsTitle()}
                                        onBack={this.onDrawerClose}
                                        tags={
                                            <Tag key={"constitution"} color={"#246079"}>
                                                {this.getActiveChecklist.getIn([0 , "dealer_constitution"])}
                                            </Tag>}
                                        extra={this.caseActions()}
                                    />
                                </Col>
                                <Col span={22} offset={1}>
                                    <PaymentProgramDetailsTabs
                                        closeDrawer={this.onDrawerClose}
                                        className={"p-10"}
                                        caseId={caseId}
                                        companyId={companyId}
                                        tab={tab}
                                        history={history}
                                        caseTaskId={this.props.case_task_id}
                                        openDocView={this.openDocumentsDrawer}
                                        viewCaseNotes={this.viewCaseNotes}
                                    />
                                </Col>
                            </Row>
                        </LoaderSkeleton>
                    </Layout>
                    {this.props.children}
                </Drawer>
            </React.Fragment>
        );
    }
}

PaymentProgramDetailsDrawer.defaultProps = {
    status: STATE_STATUS.UNFETCHED,
    supplyChainDetail: new SupplyChainRecord(),
    caseSanction: new CaseSanctionRecord(),
};

PaymentProgramDetailsDrawer.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    action: PropTypes.string,
    companyId: PropTypes.number,
    company: PropTypes.object,
    caseId: PropTypes.number,
    tab: PropTypes.string,
    taskId: PropTypes.number,
    name: PropTypes.string,
    status: PropTypes.string,
    history: PropTypes.object,
    location: PropTypes.object,
    stageId: PropTypes.number,
    case_task_id: PropTypes.number,
    children: PropTypes.array,
    userGroups: PropTypes.array,
    isUserAllowedToEdit: PropTypes.bool,
    cases: PropTypes.object,
    caseOpenedFromDrawer: PropTypes.bool,
    checklist: PropTypes.object,
    fetchPaymentProgramDetails: PropTypes.func,
    caseCheckListData : PropTypes.object,
    userDetails: PropTypes.object,
    permissions: PropTypes.object,
};

const mapStateToProps = (
    state,
    { location: { state: lState }, match: { params } }
) => {
    const companyId = state.caseDetails &&
        state.caseDetails.getIn([Number(params.caseId), "data", "company"]);
    const currentTab = state.paymentProgramDetails.get("current_tab") || "1";
    return {
        checklist: state.paymentProgramDetails.getIn([currentTab, "data"]) || [],
        loading: state.paymentProgramDetails.getIn([currentTab, "status"]),
        openedTab: currentTab,
        caseOpenedFromDrawer: lState && lState.case_details && lState.case_details.caseOpenedFromDrawer,
        caseId: Number(params.caseId),
        userGroups: state.user && state.user.getIn(["data", "groups"]).map(_ => _.id),
        name: state.companies.getIn([companyId, "data", "name"]),
        companyId: companyId,
        caseCheckListData : state.paymentProgramDetails.get("caseCheckList"),
        userDetails: state.user.get("data"),
        permissions: state.user.get("permissions"),



    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchPaymentProgramDetails
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentProgramDetailsDrawer);
